import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LeadList from '../components/LeadList';
import LeadForm from '../components/LeadForm';


const LeadsPage = () => {
    return (
        <div>
            <Routes>
                <Route path="/" element={<LeadList />} />
                <Route path="/new" element={<LeadForm />} />
                <Route path="/edit/:id" element={<LeadForm />} />

            </Routes>
        </div>
    );
};

export default LeadsPage;